import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const Research = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Research component');
    }

    const [researchData, setResearchData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch('/data/research.json')
            .then(response => response.json())
            .then(data => setResearchData(data))
            .catch(error => console.error('Error fetching research data:', error));
    }, []);

    const scrollToSkills = () => {
        const skillsSection = document.getElementById('skills');
        if (skillsSection) {
            skillsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleViewMore = () => {
        navigate('/research');
    };

    return (
        <div className="mainArea transition-effect" id="research-section">
            <div className="research transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/professional/sa4s.png"
                        alt="Research Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Research
                            </div>

                            <img
                                src="/images/siteElements/scroll-up.png"
                                alt="Scroll Up Indicator"
                                className="resScrollUp"
                                onClick={scrollToSkills}
                            />
                        </div>
                        <div className="rightContent">
                            {researchData.length > 0 ? (
                                <div className="researchContainer">
                                    {researchData.slice(-2).map((research) => (
                                        <div className="researchItem" key={research.id}>
                                            <p className="researchTitle">
                                                {research.title}
                                            </p>
                                            <p className="researchConference">{research.acceptedAt}</p>
                                            <p className="researchSummary">{research.summary}</p>
                                        </div>
                                    ))}

                                    <div className="researchViewMoreContainer">
                                        <button
                                            className="researchViewMoreButton"
                                            onClick={handleViewMore}
                                        >
                                            View More <i className="fa-solid fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="comingSoonContainer">
                                    <div className="comingSoonCard">
                                        <h2 className="comingSoonTitle">Research in Progress!</h2>
                                        <p className="comingSoonText">
                                            My research is currently undergoing peer review... by me.
                                            I'm a tough critic, ya know.
                                        </p>
                                        <p className="comingSoonText">
                                            In the meantime, imagine some really impressive graphs,
                                            a few "statistically significant" results, and at least one
                                            equation that looks way more complicated than it needs to be.
                                        </p>
                                        <p className="comingSoonText">
                                            <em>Expected timeline? Coming Soon!</em>
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/professional/thub.jpg"
                        alt="Research Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Research;
